import { render, staticRenderFns } from "./items-per-page.vue?vue&type=template&id=4058cb0e&scoped=true"
import script from "./items-per-page.vue?vue&type=script&lang=js"
export * from "./items-per-page.vue?vue&type=script&lang=js"
import style0 from "./items-per-page.vue?vue&type=style&index=0&id=4058cb0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_72a858df71aeaca8538e59a65db64572/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4058cb0e",
  null
  
)

export default component.exports